import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  card: {
    borderRadius: "3%",
    width: "95%",
    height: "30vh",
    boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2) !important",
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    minHeight: "280px",
  },
  cardContent: {
    padding: 0,
    marginTop: "5%",
  },
  wrapper: {
    display: "flex",
    width: "98%",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  box: {
    border: "solid 2px #A8ABC2",
    padding: 0,
    borderRadius: "5px",
    marginTop: "5px",
    marginRight: 2,
    marginBottom: "5px",
  },
  name: {
    textAlign: "start",
    fontWeight: 700,
    fontSize: "1vw",
    color: ({ theme }) => theme.palette.text.primary,
    fontFamily: "Rubik",
    marginBottom: "5px",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
  },
  type: {
    textAlign: "start",
    fontWeight: 500,
    fontSize: "0.8vw",
    color: ({ theme }) => theme.palette.text.primary,
    fontFamily: "Rubik",
    lineHeight: "15px",
  },
  break: {
    margin: "0 16px 12px 16px",
    color: "#A8ABC2",
    borderWidth: "1.5px",
  },
  link: {
    fontWeight: "600px",
    fontSize: "0.7vw",
    height: "2vw",
    fontFamily: "Rubik",
    textAlign: "center",
    color: "#FFFFFF",
    backgroundColor: "#B80351",
    "&:hover": {
      backgroundColor: "#B80351",
    },
  },
  cardsWrapper: {
    backgroundColor: ({ theme }) => theme.palette.themeColor,
  },
  container: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end",
    minHeight: "679px",
  },
  productWrapper: {
    zIndex: "1234",
    paddingBottom: "1%",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    margin: "-1.5% 3% 0",
    width: ({ isNavbarOpen }) => `calc(100% - ${isNavbarOpen ? "23%" : "12%"})`,
    "@media (min-width: 1921px)": {
      margin: "-1% 3% 0",
    },
  },
  grid: {
    padding: "0 16px 0 16px",
    marginBottom: 0,
    height: "10vh",
    minHeight: "85px",
  },
  content: {
    backgroundColor: "#FFFFFF",
    width: "85%",
    height: "80%",
    paddingRight: "5px",
  },
  productImg: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  nameWrapper: {
    paddingLeft: "10%",
  },
  loadingWrapper: {
    width: "90vw",
    height: "80vh",
  },
});
